'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-env browser */
/* eslint-disable class-methods-use-this */
var gelato_error_logger_1 = require("@bumble/gelato-error-logger");
var GelatoClient = /** @class */ (function () {
    function GelatoClient(options) {
        this.debug = Boolean(options.debug);
        this.errorLogger = (0, gelato_error_logger_1.createErrorLogger)({
            getErrorLogUrl: function () { return options.url; },
            addGlobals: function (errorDetails) {
                errorDetails.app_version = options.staticVersion || 'unknown';
                errorDetails.deploy_info = options.environment || 'unknown';
                errorDetails.app_label = options.token;
                errorDetails.current_url = document.location.href;
                errorDetails.lang = navigator.language || '';
                errorDetails.device_id = options.deviceId;
            },
            isDebug: this.debug,
        });
    }
    GelatoClient.prototype.trackMessage = function (message, details) {
        this.errorLogger(new gelato_error_logger_1.ErrorMessage('Error', message, this.debug), this.getErrorDetails(details));
    };
    GelatoClient.prototype.trackError = function (error, details) {
        this.errorLogger(error, this.getErrorDetails(details));
    };
    GelatoClient.prototype.getErrorDetails = function (details) {
        return {
            debug_info: details === null || details === void 0 ? void 0 : details.debugInfo,
            level: details === null || details === void 0 ? void 0 : details.level,
            origin: details === null || details === void 0 ? void 0 : details.origin,
        };
    };
    return GelatoClient;
}());
exports.default = GelatoClient;
